import { useEffect, useRef, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
const promiseAllObject = async (object)=>{
    return Object.fromEntries(await Promise.all(Object.entries(object).map(async ([key, promise])=>{
        return [
            key,
            await promise
        ];
    })));
};
export const usePromiseHash = (initialObject)=>{
    const [promise, setPromise] = useState(()=>{
        return initialObject ? initialObject() : null;
    });
    const [isLoading, setIsLoading] = useState(!!promise);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);
    const lastPromise = useRef(null);
    useEffect(()=>{
        lastPromise.current = promise;
        setIsLoading(!!promise);
        setResult(null);
        setError(null);
        if (promise) {
            (async ()=>{
                try {
                    const res = await promiseAllObject(promise);
                    if (promise === lastPromise.current) {
                        unstable_batchedUpdates(()=>{
                            setResult(res);
                            setIsLoading(false);
                        });
                    }
                } catch (err) {
                    if (promise === lastPromise.current) {
                        unstable_batchedUpdates(()=>{
                            setError(err);
                            setIsLoading(false);
                        });
                    }
                }
            })();
        }
    }, [
        promise
    ]);
    return {
        isLoading,
        result,
        error,
        exec: setPromise
    };
};
